// TODO: As spoken with Eze, this should be a component not related to coupons
// General expandable card not composed of ul and li but of divs
// Please, update me
import React from 'react';
import List from 'BVComponents/list';

export default (props) => (
  <List expandable {...props} />
);
